import { render } from "./invitado_evento_ingles.vue?vue&type=template&id=2d56111c&scoped=true"
import script from "./invitado_evento_ingles.vue?vue&type=script&lang=js"
export * from "./invitado_evento_ingles.vue?vue&type=script&lang=js"

import "./invitado_evento_ingles.vue?vue&type=style&index=0&id=2d56111c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d56111c"]])

export default __exports__